export const TASK_DEPENDENCY_ORIGIN_POINT = {
  FINISH: "FINISH",
  START: "START",
};
